interface PaginationProps {
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onPageChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages = Array.from({ length: totalPages }, (_, index) => index + 1);

  return (
    <nav aria-label="分页导航" className="mt-10 flex flex-wrap items-center justify-center gap-2">
      <button
        type="button"
        onClick={() => onPageChange(page - 1)}
        disabled={page === 1}
        className="flex h-9 items-center gap-1 rounded-md border border-background-300 px-3 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700 disabled:cursor-not-allowed disabled:opacity-40"
      >
        <i className="ri-arrow-left-s-line"></i>
        上一页
      </button>
      {pages.map((item) => (
        <button
          key={item}
          type="button"
          onClick={() => onPageChange(item)}
          aria-current={item === page ? "page" : undefined}
          className={`h-9 w-9 rounded-md font-label text-sm transition-colors ${
            item === page
              ? "bg-primary-700 text-background-50"
              : "border border-background-300 text-foreground-700 hover:border-primary-300 hover:text-primary-700"
          }`}
        >
          {item}
        </button>
      ))}
      <button
        type="button"
        onClick={() => onPageChange(page + 1)}
        disabled={page === totalPages}
        className="flex h-9 items-center gap-1 rounded-md border border-background-300 px-3 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700 disabled:cursor-not-allowed disabled:opacity-40"
      >
        下一页
        <i className="ri-arrow-right-s-line"></i>
      </button>
    </nav>
  );
}